import { URI_MESSAGES_SERVICE } from '@/config/config';
export default async ({ rootState }) => {
  const token = rootState['DATA-ACCESS'].tokenAuth;
  const opts = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      'user-token': rootState['DATA-ACCESS'].userToken,
      Authorization: `Bearer ${token}`,
    },
  };
  const response = await fetch(`${URI_MESSAGES_SERVICE}users/online`, opts);
  const jsonResult = await response.json();
  if (response.status >= 400) {
    throw new Error(jsonResult);
  }

  return jsonResult.data;
};
